module.exports = __webpack_public_path__ + "img/Logo 2.5a05e30e.png";